export default __webpack_public_path__ + "static/environmental-banner-ec7ed8bc87a1d65903203f5a13c23d0e.png";